<template>
  <div id="SelersList">
    <div class="recom_slide">
      <div class="slide_box" v-for="(item,index) in list" :key="index">
        <div @click="recom_del(item.ID)" class="recom_del" v-if="type=='tab'"></div>
        <!-- <span class="favorite" :class="item.IsAttention ? 'on' : ''" v-if="type!='tab'&&userInfo != null" @click="favorite(item)"></span> -->
        <router-link :to="{ path: '/seller/detail/'+(type=='tab'?item.ID:item.Id)}"  target="_blank">
          <div class="recom_img_box">
            <!-- <el-image class="recom_img" :src="item.StoreLogo!='没有可上传的图片'?item.StoreLogo:'../static/images/noimg.svg'" fit="scale-down" v-if="type=='tab'" ></el-image>
            <el-image class="recom_img" :src="item.StoreLogo!='没有可上传的图片'?item.StoreLogo:'../static/images/noimg.svg'" fit="scale-down" v-else lazy></el-image> -->
            <el-image class="recom_img" :src="item.StoreLogo" fit="scale-down" lazy>
              <img slot="error" src="../../../static/images/noimg.svg" class="el-image__inner" style="object-fit: contain;">
            
            </el-image>
          </div>
          <div class="slide_txt" v-if="type=='tab'">
            <p class="line_txt2">{{item.StoreName}}</p>
            <span><i> {{$tc('base.itemsForSale',item.SellCount,{ n: item.SellCount })}}</i></span>
            <span><i> {{$tc('base.followers',item.AttentionCount,{ n: item.AttentionCount })}}</i></span>
            <span>{{item|setFeedback}}<i> {{$t('base.positive')}}</i></span>
          </div>
          <div class="slide_txt" v-else>
            <p class="line_txt2">{{ item.StoreName}}</p>
            <span><i>{{$tc('base.itemsForSale',item.CommoditySellCount,{ n: item.CommoditySellCount })}}</i></span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo,setAttention } from "@/api/public";
import qs from 'qs'
export default {
  name: 'selerslist',
  data() {
    return {
      userInfo:'',
      ifDelete:false,
    }
  },
  props: {
    list: {},
    type: String,
  },
  filters: {
    //百分比
    setFeedback(val) {
      var FavorableCount=(val.BuyFavorableCount+val.SellFavorableCount)
      var TotalCount=(val.BuyFavorableCount + val.SellFavorableCount + val.BuyNegativeCount+val.SellNegativeCount)
      let data=((FavorableCount/TotalCount)*100)
      if(TotalCount>0){
        if(data!=100){
          data=data.toFixed(2)
        }
      }else{
        data=100
      }
      return data+'%'
    }
  },
  created() {
    this.userInfo = getInfo()
    //console.log(this.list)
  },
  methods: {

    favorite(obj){
      let id=obj.Id;
      obj.IsAttention=!obj.IsAttention;
      setAttention(id,1)
    },
    recom_del(val) {
      let that = this
      let data = { 'selluserid': val, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
      this.$post(this.$interface.SetAttention, qs.stringify(data)).then(res => {
        //console.log(res)
        if (res.result != 0) {
          this.$emit('updatedSeller')
        }

      })
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/sellerslist.css";

</style>



// WEBPACK FOOTER //
// src/components/list/sellers.vue